import React from 'react';
import ReactDOM from 'react-dom/client'; // Use `react-dom/client`
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import { ThemeProvider } from './app/context/ThemeContext';
import "./assets/styles/dark-theme.css";
import { SideBarProvider } from './app/context/SideBarContext';
const RO_ERR = /ResizeObserver loop/;
window.addEventListener("error", (e) => {
    if (RO_ERR.test(e.message)) {
        const overlay = document.getElementById("webpack-dev-server-client-overlay");
        const overlayDiv = document.getElementById("webpack-dev-server-client-overlay-div");
        if (overlay) overlay.style.display = "none";
        if (overlayDiv) overlayDiv.style.display = "none";
        e.stopImmediatePropagation();
    }
});
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename='/user/'>
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <SideBarProvider>
                    <App />
                </SideBarProvider>
            </ThemeProvider>
        </QueryClientProvider>
    </BrowserRouter>
);
